import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { certificationsData } from '../data/certifications';
import { CertificationCard } from '../components/CertificationCard';
import { PartnerCTA } from '../components/PartnerCTA';
export function WhatWeDoPage() {
  const featureBlocks = [{
    title: 'Trusted & Tailored',
    image: 'https://images.unsplash.com/photo-1580894894513-541e068a3e2b?w=800&q=80',
    copy: 'We hold comprehensive experience in government contracts, private tenders and specialist equipment procurement by working collaboratively with clients to design, develop and deliver dependable solutions.'
  }, {
    title: 'Protective Gear',
    image: 'https://images.unsplash.com/photo-1579912437766-7896df6d3cd3?w=800&q=80',
    copy: "Chiltern Global's team consists of former police, security and military professionals which provides us with experience of field conditions, innovation and end user needs; therefore, enabling us to select and audit trusted manufacturing partners and ensure every product we create, meets the levels of quality, durability and compliance, beyond the requirements."
  }, {
    title: 'Global Excellence',
    image: 'https://images.unsplash.com/photo-1544027993-37dbfe43562a?w=800&q=80',
    copy: "Concept and prototyping to production and delivery- Chiltern Global manages every step of the process, insuring adherence to technical specifications, industry certifications and international defence standards. We pride ourselves on providing our clients with reliable equipment that's built for performance and longevity."
  }, {
    title: 'Defence Procurement',
    image: 'https://images.unsplash.com/photo-1617791160505-6f00504e3519?w=800&q=80',
    copy: 'With a highly experienced research and development team using innovative technologies Chiltern Global designs, develops and manufactures a comprehensive range of specialist textile products. This includes clothing, footwear, bags, backpacks, outdoor sleeping systems, load carriage, ballistic, riot, CBRN and other specialist protective equipment.'
  }, {
    title: 'Police Frameworks',
    image: 'https://images.unsplash.com/photo-1557862921-37829c790f19?w=800&q=80',
    copy: 'With a highly experienced research and development team using innovative technologies Chiltern Global designs, develops and manufactures a comprehensive range of specialist textile products. This includes clothing, footwear, bags, backpacks, outdoor sleeping systems, load carriage, ballistic, riot, CBRN and other specialist protective equipment.'
  }];
  const partners = [{
    name: 'Make UK Defence',
    url: 'https://www.makeuk.org/about/make-uk-defence',
    logo: 'https://cdn.magicpatterns.com/uploads/cfP4ywzNizUEjpNhgJmApG/Make_UK_Defence_Logo_Col_72dpi_002_002.png'
  }, {
    name: 'Armed Forces Covenant',
    logo: 'https://cdn.magicpatterns.com/uploads/gUUdKgzQzHWsQRqAAQwxq7/AFC_POSITIVE_RGB.png'
  }, {
    name: 'Cyber Essentials Plus',
    logo: 'https://cdn.magicpatterns.com/uploads/13vUPeUkJ8i5oDWP9yZJcD/cyberessentials_certification-mark-plus_colour.png'
  }, {
    name: 'ISO 9001:2015',
    logo: 'https://cdn.magicpatterns.com/uploads/du9xSAnpmrfhYGmqcMzu2B/UKAS_9001.png'
  }, {
    name: 'ISO 14001:2015',
    logo: 'https://cdn.magicpatterns.com/uploads/c6RGX87GDb7n4CWSe5fWPD/ISO_140001.png'
  }, {
    name: 'JOSCAR',
    logo: 'https://cdn.magicpatterns.com/uploads/byihqp9gceccmuWddiSZfV/Joscar.png'
  }, {
    name: 'Disability Confident',
    logo: 'https://cdn.magicpatterns.com/uploads/8XG2XHqH34Hii3s1MmkT7X/dc_badge1.png'
  }, {
    name: 'ADS',
    url: 'https://www.adsgroup.org.uk',
    logo: 'https://cdn.magicpatterns.com/uploads/wkQpRYtwzEksVJ7NSu1naU/ADS.png'
  }, {
    name: 'Watford & West Herts Chamber of Commerce',
    logo: 'https://cdn.magicpatterns.com/uploads/87KVCewgCkuKpmjwMFudRC/watford_logo.png'
  }];
  return <>
      {/* 1. HERO BANNER */}
      <PageHero label="About Us" title="What We Do" subtitle="Over 20 years of expertise in manufacturing. We are suppliers to international defence contracts, and major police and prison forces. Through our UK based assembly line and vetted global partners, we provide high quality equipment to the defence, police, prison and medical sectors." backgroundImage="https://images.unsplash.com/photo-1579912437766-7896df6d3cd3?w=1600&q=80" data-id="element-1626" />

      {/* CTA Row Below Hero */}
      <div className="bg-navy-900 py-6 border-b border-white/5" data-id="element-1627">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1628">
          <Link to="/contact" className="inline-flex items-center justify-center px-10 py-4 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider rounded-sm transition-colors" data-id="element-1629">
            Contact for More
          </Link>
        </div>
      </div>

      {/* 2. BREADCRUMBS */}
      <Breadcrumbs items={[{
      label: 'About Us',
      to: '/about'
    }, {
      label: 'What We Do'
    }]} data-id="element-1630" />

      {/* 3. INTRO CONTENT SECTION */}
      <section className="bg-white py-24" data-id="element-1631">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1632">
          <h2 className="text-3xl font-bold text-navy-900 mb-6" data-id="element-1633">What We Do</h2>
          <p className="text-lg text-steel-600 leading-relaxed max-w-4xl" data-id="element-1634">
            Chiltern Global is a leading UK manufacturer, recognised for
            supplying equipment to the police, military, security and medical
            sectors. As a company, provide Custom manufacturing solutions
            tailored to meet strict operational standards of the law
            enforcement, security organisations and armed forces globally.
          </p>
        </div>
      </section>

      {/* 4. FEATURE BLOCKS SECTION */}
      <section className="bg-slate-50 py-20 border-t border-steel-200" data-id="element-1635">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1636">
          <span className="text-cg-orange-600 font-bold uppercase tracking-widest text-sm mb-2 block" data-id="element-1637">
            Our Capabilities
          </span>
          <h2 className="text-3xl font-bold text-navy-900 mb-10" data-id="element-1638">
            Military & Protective Textiles
          </h2>

          <div className="flex flex-col gap-8" data-id="element-1639">
            {/* Top Row: 2 Columns */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1640">
              {featureBlocks.slice(0, 2).map((block, index) => <div key={index} className="bg-white border border-steel-200 rounded-sm overflow-hidden shadow-sm hover:shadow-md hover:border-cg-orange-600 transition-all duration-300 flex flex-col group relative" data-id="element-1641">
                  <div className="absolute top-0 left-0 right-0 h-[2px] bg-cg-orange-600 z-10" data-id="element-1642" />
                  <div className="h-48 overflow-hidden relative" data-id="element-1643">
                    <div className="absolute inset-0 bg-navy-900/5 group-hover:bg-transparent transition-colors z-10" data-id="element-1644" />
                    <img src={block.image} alt={block.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-1645" />
                  </div>
                  <div className="p-6 flex flex-col flex-1" data-id="element-1646">
                    <h3 className="text-lg font-bold text-navy-900 mb-3 group-hover:text-cg-orange-600 transition-colors" data-id="element-1647">
                      {block.title}
                    </h3>
                    <p className="text-sm text-steel-600 leading-relaxed flex-1" data-id="element-1648">
                      {block.copy}
                    </p>
                  </div>
                </div>)}
            </div>

            {/* Bottom Row: 3 Columns */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1649">
              {featureBlocks.slice(2).map((block, index) => <div key={index + 2} className="bg-white border border-steel-200 rounded-sm overflow-hidden shadow-sm hover:shadow-md hover:border-cg-orange-600 transition-all duration-300 flex flex-col group relative" data-id="element-1650">
                  <div className="absolute top-0 left-0 right-0 h-[2px] bg-cg-orange-600 z-10" data-id="element-1651" />
                  <div className="h-40 overflow-hidden relative" data-id="element-1652">
                    <div className="absolute inset-0 bg-navy-900/5 group-hover:bg-transparent transition-colors z-10" data-id="element-1653" />
                    <img src={block.image} alt={block.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-1654" />
                  </div>
                  <div className="p-6 flex flex-col flex-1" data-id="element-1655">
                    <h3 className="text-lg font-bold text-navy-900 mb-3 group-hover:text-cg-orange-600 transition-colors" data-id="element-1656">
                      {block.title}
                    </h3>
                    <p className="text-sm text-steel-600 leading-relaxed flex-1" data-id="element-1657">
                      {block.copy}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* 5. CERTIFICATIONS & ACCREDITATIONS SECTION */}
      <section className="bg-white py-20 border-t border-steel-200" data-id="element-1658">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1659">
          <span className="text-cg-orange-600 font-bold uppercase tracking-widest text-sm mb-2 block" data-id="element-1660">
            Our Credentials
          </span>
          <h2 className="text-3xl font-bold text-navy-900 mb-12" data-id="element-1661">
            Certifications & Accreditations
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1662">
            {certificationsData.map(card => <CertificationCard key={card.id} card={card} data-id="element-1663" />)}
          </div>
        </div>
      </section>

      {/* 6. CTA SECTION */}
      <PartnerCTA data-id="element-1664" />
    </>;
}